import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import MacroOffIcon from "@mui/icons-material/MacroOff";
import icon1 from "../../../Image/icon1.png";
import icon2 from "../../../Image/icon2.png";
import icon3 from "../../../Image/icon3.png";
import icon4 from "../../../Image/icon4.png";
import icon5 from "../../../Image/icon5.png";
import icon6 from "../../../Image/icon6.png";
import icon7 from "../../../Image/icon7.png";
import icon8 from "../../../Image/icon8.png";
import icon9 from "../../../Image/icon9.png";
import icon10 from "../../../Image/icon10.png";
import icon11 from "../../../Image/icon11.png";
import icon12 from "../../../Image/icon12.png";
import icon13 from "../../../Image/icon13.png";
import icon14 from "../../../Image/icon14.png";
import icon15 from "../../../Image/icon15.png";
import icon16 from "../../../Image/icon16.png";
import icon17 from "../../../Image/icon17.png";
import icon18 from "../../../Image/icon18.png";
import icon19 from "../../../Image/icon22.png";
import icon20 from "../../../Image/icon20.png";
import icon21 from "../../../Image/icon21.png";
import icon29 from "../../../Image/icon22.png";
import icon22 from "../../../Image/icon23.png";
import icon23 from "../../../Image/icon24.png";
import icon24 from "../../../Image/icon25.png";
import icon36 from "../../../Image/icon36.png";

import "./index.css";

const Avialable = () => {
  return (
    <div>
      {/* Avialble */}
      <div
        style={{
          backgroundColor: "rgb(255, 184, 0)",
          borderBottom: "2px solid white",
        }}
        id="we_Avialable"
      >
        <h1
          style={{
            textAlign: "center",
            color: "black",
            paddingTop: "30px",
            paddingBottom: "30px",
            fontFamily: "Times New Roman, Times, serif",
          }}
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <b>We Are Avialable</b>{" "}
        </h1>
        <Container>
    
          <Grid
            container
            className="avialble_main"
            style={{ marginTop: "20px" }}
          >
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon5} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon6} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon7} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon8} alt="" style={{ justifyContent: "center" }} />
            </Grid>
          </Grid>

          <Grid container className="avialble_main1">
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon9} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon10} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon11} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon12} alt="" style={{ justifyContent: "center" }} />
            </Grid>
          </Grid>
          <Grid
            container
            className="avialble_main1"
            style={{ paddingBottom: "40px" }}
          >
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon13} alt="" style={{ justifyContent: "center" }} />
            </Grid>
              
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon3} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon1} alt="" style={{ justifyContent: "center" }} />
            </Grid>

            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text"
              style={{textAlign:'center',backgroundColor:"rgb(255,138,0)",border:'2px solid white'}}

            >
              <img src={icon15} alt="" style={{ justifyContent: "center" }} />
            </Grid>
         
         
          </Grid>
        </Container>
      </div>
      {/* COMMING SOON */}
      <div style={{ backgroundColor: "rgb(255,138,0)" }}>
        <h1
          style={{
            textAlign: "center",
            color: "black",
            paddingTop: "30px",
            paddingBottom: "30px",
            fontFamily: "Times New Roman, Times, serif",
          }}
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <b>Coming Soon</b>{" "}
        </h1>
        <Container>
          <Grid container className="avialble_main">
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text_comming"
              style={{ textAlign: "center" }}
            >
              <img src={icon17} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text_comming"
              style={{ textAlign: "center" }}
            >
              <img src={icon18} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text_comming"
              style={{ textAlign: "center" }}
            >
              <img src={icon19} alt="" style={{ justifyContent: "center" }} />
            </Grid>
          </Grid>
          <Grid
            container
            className="avialble_main"
            style={{ marginTop: "30px" }}
          >
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text_comming"
              style={{ textAlign: "center" }}
            >
              <img src={icon20} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text_comming"
              style={{ textAlign: "center" }}
            >
              <img src={icon21} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text_comming"
              style={{ textAlign: "center" }}
            >
              <img src={icon24} alt="" style={{ justifyContent: "center" }} />
            </Grid>
          </Grid>
          <Grid
            container
            className="avialble_main"
            style={{ marginTop: "30px", paddingBottom: "70px" }}
          >
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text_comming"
              style={{ textAlign: "center" }}
            >
              <img src={icon23} alt="" style={{ justifyContent: "center" }} />
            </Grid>
            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              className="avialable_text_comming"
              style={{ textAlign: "center" }}
            >
                          <img src={icon36} alt="" style={{ justifyContent: "center" }} />

            </Grid>
      

            <Grid
              item
              lg={2.5}
              md={2.5}
              sm={3.3}
              xs={6}
              // className="avialable_text_comming"
              // style={{ textAlign: "center" }}
              // id="avialable_text"
            >
              {/* <img src={icon29} alt="" style={{ justifyContent: "center" }} /> */}
            </Grid>
          </Grid>
        </Container>
        <div
          style={{
            borderBottom: "1px solid rgb(54,54,54)",
            marginBottom: "30px",
            paddingTop: "30px",
          }}
        ></div>
        <div style={{ paddingTop: "10px" }}></div>
      </div>

      {/* Subscribe */}

      <div
        style={{
          backgroundColor: "rgb(54,54,54)",
          borderBottom: "2px solid white",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "black",
            paddingTop: "30px",
            paddingBottom: "30px",
            color: "white",
            fontFamily: "Times New Roman, Times, serif",
          }}
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <b>Subscribe Your Letter</b>
        </h1>

        <Container>
          <Grid container>
            <Grid item lg={4} md={4} sm={4}></Grid>
            <Grid
              item
              lg={4}
              md={4}
              sm={4}
              style={{ textAlign: "center", marginTop: "-30px" }}
            >
              <div style={{ borderBottom: "2px solid white" }}></div>
            </Grid>
          </Grid>
          <Grid
            container
            style={{
              justifyContent: "center",
              marginTop: "20px",
              marginBottom: "30px",
            }}
          >
            <Grid item lg={6} md={6} sm={6}>
              <Grid
                container
                style={{ backgroundColor: "gray", borderRadius: "8px" }}
              >
                <Grid item lg={8} md={8} sm={8}>
                  <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      backgroundColor: "transparent",
                      padding: "10px",
                      paddingLeft: "18px",
                      paddingTop: "20px",
                      cursor: "pointer",
                    }}
                    placeholder="Enter Your Email"
                    className="input_email"
                  />
                </Grid>

                <Grid item lg={2} md={1} sm={0.5}></Grid>

                <Grid item lg={2} md={2} sm={2}>
                  <Button
                    style={{
                      backgroundColor: "rgb(255,138,0)",
                      color: "white",
                      margin: "5px",
                      borderRadius: "8px",
                      marginTop: "10px",
                    }}
                  >
                    <b>Submit</b>
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <div
          style={{
            borderBottom: "1px solid gray",
            marginBottom: "30px",
            paddingTop: "30px",
          }}
        ></div>
        <div style={{ paddingTop: "10px" }}></div>
      </div>
    </div>
  );
};

export default Avialable;
